
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import { Component, Ref } from "vue-property-decorator";
import TextFloating from "@/components/input/TextFloating.vue";
import SelectAutocomplete from "@/components/input/SelectAutocomplete.vue";
import FileInput from "@/components/input/FileInput.vue";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import MachineModel from "@/models/MachineModel";
import CategoryModel from "@/models/CategoryModel";
import UrgencyModel from "@/models/UrgencyModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { BContainer, BRow, BCol } from "bootstrap-vue";
import LoadingOverlay from "@/components/overlay/LoadingOverlay.vue";
@Component({
    components: {
        BRow,
        BContainer,
        BCol,
        SubHeader,
        TextFloating,
        FileInput,
        SelectAutocomplete,
        ValidationObserver,
        ValidationProvider,
        LoadingOverlay,
    },
})
export default class CreateTicket extends Vue {
    mounted() {
        this.loadCateogry();
        this.loadUrgency();
        this.loadRegions();
        this.loadLocations();
    }
    titlePage = "New Ticket";
    subTitlePage = "";
    infoStep = "Complete the information";
    step = "1";
    displayCategory = false;
    displayUploadTicket = false;
    displayDescription = true;

    area: string | null = null;
    section: string | null = null;
    line: string | null = null;
    subline: string | null = null;
    subMachine: string | null = null;

    isActive = false;
    isActiveMachine = false;
    isActiveDesc = false;
    isActiveLevel = false;
    isActiveRegion = false;
    isActiveLocation = false;

    isActiveArea = false;
    isActiveSection = false;
    isActiveLine = false;
    isActiveSubline = false;
    isActiveSubMachine = false;

    isActiveTelegram = false;
    isActivePhoneNumber = false;

    isActivePhone = false;
    isActiveTele = false;
    subject: string | null = null;
    category: string | null = null;
    subCategory: string | null = null;
    statusCategory = false;
    keyword: string | null = null;

    listMachine: { value: string | null; text: string | null }[] = [];
    listUrgency: { value: string | null; text: string | null }[] = [];
    listRegions: { value: string | null; text: string | null }[] = [];
    listLocations: { value: string | null; text: string | null }[] = [];
    listArea: { value: string | null; text: string | null }[] = [];
    listSection: { value: string | null; text: string | null }[] = [];
    listLine: { value: string | null; text: string | null }[] = [];
    listSubline: { value: string | null; text: string | null }[] = [];
    listEquipment: { value: string | null; text: string | null }[] = [];

    listRegionss: any[] = [];

    listImage: AttachmentModel[] = [];
    listCategory: CategoryModel[] = [];
    ticket: TicketModel = new TicketModel();

    @Ref() categorySelect!: HTMLElement;

    showOverlay = false;

    loadArea() {
        const region_code = this.listRegionss.find(
            (x) => x.id == this.ticket.ref_regions_id
        )?.code;
        return new Promise((resolve, reject) => {
            api.options
                .getAreas(region_code)
                .then((response) => {
                    if (response.data.code === 200) {
                        const result = response.data.data;
                        this.listArea = [];
                        result.forEach((element) => {
                            this.listArea.push({
                                value: String(element.area_code),
                                text:
                                    element.area_label +
                                    " (" +
                                    element.area_code +
                                    ")",
                            });
                        });
                        this.ticket.fl_section_code = null;
                        this.ticket.fl_line_code = null;
                        this.ticket.fl_sub_line_code = null;
                        this.ticket.fl_equipment_code = null;

                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }
    loadSection() {
        return new Promise((resolve, reject) => {
            api.options
                .getSections(this.ticket.fl_area_code)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.listSection = [];
                        const result = response.data.data;
                        result.forEach((element) => {
                            this.listSection.push({
                                value: String(element.section_code),
                                text:
                                    element.section_label +
                                    " (" +
                                    element.section_code +
                                    ")",
                            });
                        });

                        this.ticket.fl_line_code = null;
                        this.ticket.fl_sub_line_code = null;
                        this.ticket.fl_equipment_code = null;
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }
    loadLine() {
        return new Promise((resolve, reject) => {
            api.options
                .getLines(this.ticket.fl_section_code)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.listLine = [];
                        const result = response.data.data;
                        result.forEach((element) => {
                            this.listLine.push({
                                value: String(element.line_code),
                                text:
                                    element.line_label +
                                    " (" +
                                    element.line_code +
                                    ")",
                            });
                        });

                        this.ticket.fl_sub_line_code = null;
                        this.ticket.fl_equipment_code = null;
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }
    loadSubline() {
        return new Promise((resolve, reject) => {
            api.options
                .getSublines(this.ticket.fl_line_code)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.listSubline = [];
                        const result = response.data.data;
                        result.forEach((element) => {
                            if(element.sub_line_code == null) return
                            this.listSubline.push({
                                value: String(element.sub_line_code),
                                text:
                                    element.sub_line_label +
                                    " (" +
                                    element.sub_line_code +
                                    ")",
                            });
                        });
                        this.ticket.fl_equipment_code = null;
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }
    loadEquipment(code: string) {
        return new Promise((resolve, reject) => {
            api.options
                .getMachines(code)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.listEquipment = [];
                        const result = response.data.data;
                        result.forEach((element) => {
                            this.listEquipment.push({
                                value: String(element.equipment_code),
                                text:
                                    element.equipment_label +
                                    " (" +
                                    element.equipment_code +
                                    ")",
                            });
                        });
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    loadRegions() {
        return new Promise((resolve, reject) => {
            api.options
                .getRegions()
                .then((response) => {
                    if (response.data.code === 200) {
                        const result = response.data.data;
                        result.forEach((element) => {
                            this.listRegions.push({
                                value: String(element.id),
                                text: element.name,
                            });
                            this.listRegionss.push(element);
                        });
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    loadLocations() {
        return new Promise((resolve, reject) => {
            api.options
                .getLocations()
                .then((response) => {
                    if (response.data.code === 200) {
                        const result = response.data.data;
                        result.forEach((element) => {
                            this.listLocations.push({
                                value: String(element.id),
                                text: element.name + ` (${element.area_code})`,
                            });
                        });
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    loadCateogry() {
        return new Promise((resolve, reject) => {
            api.options
                .getCategories()
                .then((response) => {
                    if (response.data.code === 200) {
                        this.listCategory = [...response.data.data];
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }
    loadUrgency() {
        this.listUrgency = [];
        this.listUrgency.push({ value: null, text: "Urgency Level" });
        return new Promise((resolve, reject) => {
            api.options
                .getUrgencyLevel()
                .then((response) => {
                    if (response.data.code === 200) {
                        const result = response.data.data as UrgencyModel[];
                        result.forEach((element) => {
                            this.listUrgency.push({
                                value: element.key,
                                text: element.label,
                            });
                        });
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }
    // loadMachine() {
    //   this.listMachine = [];
    //   return new Promise((resolve, reject) => {
    //     api.options
    //       .getMachine(this.keyword)
    //       .then((response) => {
    //         if (response.data.code === 200) {
    //           const result = response.data.data as MachineModel[];
    //           result.forEach((element) => {
    //             this.listMachine.push({
    //               value: String(element.id),
    //               text: element.name,
    //             });
    //           });
    //           resolve(response);
    //         }
    //       })
    //       .catch((err: any) => {
    //         reject(err);
    //         this.$swal("Error", err?.response?.data?.message, "error");
    //       });
    //   });
    // }

    chooseCategory(item: CategoryModel) {
        this.category = item.title;
        this.ticket.ticket_categories_id = item.id;
    }
    onChangeSubCategory(event) {
        this.subCategory = event.target.name;
    }
    checkRegion() {
        if (this.ticket.ref_regions_id !== null) {
            this.isActiveRegion = true;
            this.loadArea();
        } else if (this.ticket.ref_regions_id === null) {
            this.isActiveRegion = false;
        }
    }
    checkLocation() {
        if (this.ticket.ref_locations_id !== null) {
            this.isActiveLocation = true;
        } else if (this.ticket.ref_locations_id === null) {
            this.isActiveLocation = false;
        }
    }
    checkArea() {
        // console.log(this.ticket.fl_area_code);
        if (this.ticket.fl_area_code !== null) {
            this.isActiveArea = true;
            this.loadSection();
        } else if (this.ticket.fl_area_code === null) {
            this.isActiveArea = false;
        }
    }
    checkSection() {
        if (this.ticket.fl_section_code !== null) {
            this.isActiveSection = true;
            this.loadLine();
            this.loadEquipment(this.ticket.fl_section_code);
        } else if (this.ticket.fl_section_code === null) {
            this.isActiveSection = false;
        }
    }
    checkLine() {
        if (this.ticket.fl_line_code !== null) {
            this.isActiveLine = true;
            this.loadSubline();
            this.loadEquipment(this.ticket.fl_line_code);
        } else if (this.ticket.fl_line_code === null) {
            this.isActiveLine = false;
        }
    }
    checkSubline() {
        if (this.ticket.fl_sub_line_code !== null) {
            // this.isActiveSubline = true;
            this.loadEquipment(this.ticket.fl_sub_line_code);
        } else if (this.ticket.fl_sub_line_code === null) {
            // this.isActiveSubline = false;
        }
    }
    checkMachine() {
        if (this.ticket.fl_equipment_code !== null) {
            this.isActiveSubMachine = true;
        } else if (this.ticket.fl_equipment_code === null) {
            this.isActiveSubMachine = false;
        }
    }
    cekSubject() {
        if (this.ticket.problem_description !== "") {
            this.isActive = true;
        } else if (this.ticket.problem_description === "") {
            this.isActive = false;
        }
    }
    cekEquipment() {
        if (this.ticket.fl_equipment_code !== null) {
            this.isActiveMachine = true;
        } else if (this.ticket.fl_equipment_code === null) {
            this.isActiveMachine = false;
        }
    }
    cekPhone() {
        if (this.ticket.telegram_phone !== null) {
            this.isActivePhone = true;
        } else if (this.ticket.telegram_phone === null) {
            this.isActivePhone = true;
        }
    }

    cekTelegram() {
        if (this.ticket.telegram_id !== null) {
            this.isActiveTelegram = true;
        } else if (this.ticket.telegram_id === null) {
            this.isActiveTelegram = false;
        }
    }
    hanldeDesc() {
        this.displayUploadTicket = true;
        this.displayDescription = false;
        this.step = "2";
    }
    cekDesc() {
        if (this.ticket.description !== "") {
            this.isActiveDesc = true;
        } else if (this.ticket.description === "") {
            this.isActiveDesc = false;
        }
    }
    cekLevel() {
        if (this.ticket.urgency_level !== null) {
            this.isActiveLevel = true;
        } else if (this.ticket.urgency_level === null) {
            this.isActiveLevel = false;
        }
    }

    addUploadImgRow() {
        const images = new AttachmentModel();
        this.ticket.attachment.push(images);
    }
    removeUploadRow(i: number) {
        this.ticket.attachment.splice(i, 1);
    }
    submitCategory() {
        if (this.ticket.ticket_categories_id) {
            this.displayCategory = false;
            this.displayUploadTicket = true;
            this.displayDescription = false;
            this.step = "2";
            // this.statusCategory = true;
            this.subTitlePage = "";
        }
    }
    uploadTicket() {
        if (this.ticket.attachment) {
            this.displayCategory = false;
            this.displayUploadTicket = false;
            this.displayDescription = true;
            this.step = "2";
            // this.statusCategory = true;
        }
    }
    cancelCategory() {
        this.$router.go(-1);
    }
    cancelUpload() {
        this.displayCategory = true;
        this.displayUploadTicket = false;
        this.displayDescription = false;
        this.step = "1";
        // this.statusCategory = false;
        this.subTitlePage = "Please Select Category";
    }
    cancelDeskripsi() {
        // this.displayCategory = false;
        this.displayUploadTicket = false;
        this.displayDescription = true;
        this.step = "1";
        // this.statusCategory = true;
    }

    submitTicket() {
        this.showOverlay = true; // Show overlay before submitting
        this.ticket.tiket_status = "new";
        api.ticket
            .saveTicket3(this.ticket)
            .then((response) => {
                if (response.data.code === 200) {
                    // Set flag to indicate coming from create ticket
                    sessionStorage.setItem('fromCreateTicket', 'true');
                    this.$router.push({ name: "home" });
                } else {
                    this.showOverlay = false; // Hide overlay when done
                    this.$swal("Peringatan", response.data.message, "warning");
                }
            })
            .catch((err: any) => {
                this.showOverlay = false; // Hide overlay when done
                this.$swal("Error", err?.response?.data?.message, "error");
            })
    }
    getImgUrl(name_image: string) {
        var images = require.context("@/assets/", false, /\.svg$/);
        return images("img/" + name_image);
    }
}
